"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = require('@angular/core');
var mdl_chip_component_1 = require('./mdl-chip.component');
var mdl_error_1 = require('./../common/mdl-error');
var MdlChipContactDirective = (function () {
    function MdlChipContactDirective(mdlChipComponent) {
        this.mdlChipComponent = mdlChipComponent;
    }
    MdlChipContactDirective.prototype.ngOnInit = function () {
        if (!this.mdlChipComponent) {
            throw new mdl_error_1.MdlStructureError('mdl-chip-contact', 'mdl-chip');
        }
    };
    MdlChipContactDirective = __decorate([
        core_1.Directive({
            selector: '[mdl-chip-contact]',
            host: {
                '[class.mdl-chip__contact]': 'true'
            }
        }),
        __param(0, core_1.Optional()),
        __param(0, core_1.Inject(core_1.forwardRef(function () { return mdl_chip_component_1.MdlChipComponent; }))), 
        __metadata('design:paramtypes', [mdl_chip_component_1.MdlChipComponent])
    ], MdlChipContactDirective);
    return MdlChipContactDirective;
}());
exports.MdlChipContactDirective = MdlChipContactDirective;
//# sourceMappingURL=../../../dist/components/chips/mdl-chip-contact.directive.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular2-mdl/dist/components/chips/mdl-chip-contact.directive.js
 ** module id = 84
 ** module chunks = 1
 **/